import {fetchApi} from 'shared/actions/fetchApi'
import {actionMap} from '../reducers/index'
import * as types from './types'
import querystring from 'querystring'
import config from 'config/applicationConfig'
import handleError from 'shared/errorHandler/actions/handleError'
import resetError from 'shared/errorHandler/actions/resetError'
import moment from 'moment'

export default () => dispatch => {
    let queryParams = querystring.stringify({
        begin:  moment().utc().add(config.sigchartOffset.minus, config.sigchartOffset.type).toISOString(),
        end: moment().utc().add(config.sigchartOffset.plus, config.sigchartOffset.type).toISOString()
    })

    dispatch({type: types.GET_SIGCHART_LIST_START})
    dispatch(resetError())
    return fetchApi('/api/fb/sigchart/list?' + queryParams)
        .then(response => response.json())
        .then(response => {
            dispatch({
                type: types.GET_SIGCHART_LIST_SUCCESS, response: response
            })
        }).catch(error => {
            dispatch({
                type: types.GET_SIGCHART_LIST_FAILURE
            })
            dispatch(handleError({message: error.message, title: 'Error loading sigcharts.'}))
        })
}

export const handler_GET_SIGCHART_LIST_START = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: true,
        data: undefined,
        selectedIds: undefined,
        loadingIds: undefined
    })
}

export const handler_GET_SIGCHART_LIST_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: action.response.SigCharts || []
    })
}

export const handler_GET_SIGCHART_LIST_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: undefined
    })
}

actionMap[types.GET_SIGCHART_LIST_START] = handler_GET_SIGCHART_LIST_START
actionMap[types.GET_SIGCHART_LIST_SUCCESS] = handler_GET_SIGCHART_LIST_SUCCESS
actionMap[types.GET_SIGCHART_LIST_FAILURE] = handler_GET_SIGCHART_LIST_FAILURE


// WEBPACK FOOTER //
// ./src/screens/sigcharts/actions/getSigchartList.js